type ZendeskCallback = () => void;

function callZendeskSafely(...args: unknown[]) {
  if (typeof window === 'undefined' || !window.zE) return false;

  try {
    window.zE(...args);
    return true;
  } catch {
    return false;
  }
}

export function hideZendeskWidget() {
  callZendeskSafely('webWidget', 'hide');
}

export function openZendeskWidget() {
  callZendeskSafely('webWidget', 'show');
  callZendeskSafely('webWidget', 'open');
}

export function openZendeskContactForm() {
  callZendeskSafely('webWidget', 'updateSettings', {
    webWidget: {
      contactForm: {
        suppress: false,
      },
      helpCenter: {
        suppress: true,
      },
    },
  });
  callZendeskSafely('webWidget', 'show');
  callZendeskSafely('webWidget', 'open');
}

export function whenZendeskReady(callback: ZendeskCallback) {
  if (typeof window === 'undefined') return;

  if (window.zE) {
    callback();
    return;
  }

  const intervalId = window.setInterval(() => {
    if (!window.zE) return;

    window.clearInterval(intervalId);
    callback();
  }, 200);
}

export function initZendeskCustomLauncher() {
  if (typeof window === 'undefined') return;

  const init = () => {
    whenZendeskReady(() => {
      hideZendeskWidget();
      callZendeskSafely('webWidget:on', 'close', hideZendeskWidget);
    });
  };

  if (document.readyState === 'complete') {
    init();
    return;
  }

  window.addEventListener('load', init, { once: true });
}

export function openZendeskWidgetWhenReady() {
  whenZendeskReady(openZendeskWidget);
}

export function openZendeskContactFormWhenReady() {
  whenZendeskReady(openZendeskContactForm);
}
